import { Config } from "./config";

const FileManagerResource = {
    base: "/api/file-manager",
    dir(params, callback) {
        Config.Connection()
            .post(this.base, params)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    upload(params, callback, progress = (event) => { }) {
        Config.Connection()
            .put(this.base, params, {
                onUploadProgress: progress
            })
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    read(params, callback) {
        Config.Connection()
            .post(`${this.base}/read`, params)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    save(params, callback, progress = (event) => { }) {
        Config.Connection()
            .post(`${this.base}/save`, params, {
                onUploadProgress: progress
            })
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    new(params, callback) {
        Config.Connection()
            .post(`${this.base}/new`, params)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    copy(params, callback) {
        Config.Connection()
            .post(`${this.base}/copy`, params)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    rename(params, callback) {
        Config.Connection()
            .post(`${this.base}/rename`, params)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
    delete(params, callback) {
        Config.Connection()
            .post(`${this.base}/delete`, params)
            .then(r => callback(r.data))
            .catch(e => callback(e.response?.data));
    },
};

export default FileManagerResource